/*
 * https://github.com/backstage/backstage/blob/master/plugins/notifications/src/hooks/useWebNotifications.ts
 */
import { useCallback, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
// import { notificationsApiRef } from '../api';
// import { rootRouteRef } from '../routes';
import { notificationsApiRef } from '@backstage/plugin-notifications';
import { notificationsRootPath } from '../routes';

/** @internal */
export function useWebNotifications(
  enabled: boolean,
  notificationsRoute: string = notificationsRootPath,
) {
  const [webNotificationPermission, setWebNotificationPermission] =
    useState('default');
  const notificationsApi = useApi(notificationsApiRef);

  const requestUserPermission = useCallback(() => {
    if (
      enabled &&
      'Notification' in window &&
      webNotificationPermission === 'default'
    ) {
      window.Notification.requestPermission().then(permission => {
        setWebNotificationPermission(permission);
      });
    }
  }, [enabled, webNotificationPermission]);

  const sendWebNotification = useCallback(
    (options: {
      id: string;
      title: string;
      description: string;
      link?: string;
    }) => {
      if (webNotificationPermission !== 'granted') {
        return null;
      }

      const notification = new Notification(options.title, {
        body: options.description,
        tag: options.id, // Prevent duplicates from multiple tabs
      });

      notification.onclick = event => {
        event.preventDefault();
        if (options.link) {
          window.open(options.link, '_blank');
          notificationsApi.updateNotifications({
            ids: [options.id],
            read: true,
          });
        } else {
          window.open(notificationsRoute);
        }
        notification.close();
      };

      return notification;
    },
    [webNotificationPermission, notificationsApi, notificationsRoute],
  );

  return { sendWebNotification, requestUserPermission };
}
